// extracted by mini-css-extract-plugin
export default {"root":"_2vKeN","image":"_3qzGy","large":"_1zJMJ","medium":"_3kCvw","small":"_2WIgG"};